'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-355/overrides/pages/(profile)/change-password/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-355/overrides/pages/(profile)/change-password/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/3a34e8f0debf"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

